<template lang="pug">
    el-dialog(title="查看详情",width="95%", :close-on-click-modal='false', :append-to-body="true" :visible.sync='visible' :modal-append-to-body='false'  @closed="reset")
      el-form(:model='dataForm', ref='dataForm', label-suffix=":" label-width="auto" )
        el-card(shadow="never")
                div(slot="header")
                    font.title() 请假设置
                el-form-item(label='培训类型')
                    span() {{dataForm.trianType_label}}
                el-form-item(label='是否允许请假')
                    span() {{dataForm.status == 1?'允许':'不允许'}}
                el-form-item(label='训前请假截止')
                    span() {{dataForm.deadline?dataForm.deadline+"小时":dataForm.deadline}}
        br
        el-card(shadow="never")
                div(slot="header")
                    font.title() 补课券设置
                el-form-item(label='补课券类型')
                    span() {{dataForm.couponType_label}}
                el-form-item(label='适用培训类型')
                    span() {{dataForm.couponApplyType_label}}
                el-form-item(label='最多发放张数')
                    span() {{dataForm.trianCouponCount?dataForm.trianCouponCount+"张":dataForm.trianCouponCount}}
                el-form-item(label='补课券有效期')
                    span() {{dataForm.validity?dataForm.validity+"天":dataForm.validity}}
      span.dialog-footer(slot='footer')
        el-button(@click='visible = false') 返回
</template>

<script>
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        trianType_label: null,
        status: null,
        deadline: null,
        couponType_label: null,
        couponApplyType_label: null,
        trianCouponCount: null,
        validity: null
      }
    };
  },
  methods: {
    init (row) {
      this.visible = true;
      let {
        trianType_label,
        status,
        deadline,
        couponType_label,
        couponApplyType_label,
        trianCouponCount,
        validity
      } = row;
      this.dataForm = {
        trianType_label,
        status,
        deadline,
        couponType_label,
        couponApplyType_label,
        trianCouponCount,
        validity
      };
    },
    reset () {
      this.dataForm = {};
    }
  }
};
</script>
<style lang="scss" scoped>
.title {
  font-weight: bold;
  font-size: 18px;
}
</style>
